export enum Routes {
  EaseStorage = 'billing/message_storage',
  // OfferingsPatch is used for the new "OES Source Of Truth" plan updates
  OfferingsPatch = 'accounts/offerings',
}
